import { openModal } from '../helpers/modals.js';

const selectors = {
  toggleModal: '[data-toggle-modal]',
};

/**
 * Initializes modal open triggers (`[data-toggle-modal]`) via document-level delegation
 * so toggles inside Section-rendered or AJAX-injected markup (e.g. quick shop) work.
 *
 * Emits:
 *   'modal:opened' (CustomEvent) on the modal element when opened. Event detail contains { id: modalId }
 *   'modal:closed' (CustomEvent) on the modal element when closed. Event detail contains { id: modalId }
 *
 * Behavior:
 *   - Clicking the modal backdrop (outside modal content) will close the modal.
 */
export default function initModals() {
  document.addEventListener('click', event => {
    const toggle = event.target.closest(selectors.toggleModal);
    if (!toggle) {
      return;
    }

    const modalId = toggle.getAttribute('data-toggle-modal');
    if (!modalId) {
      return;
    }

    event.preventDefault();
    openModal(modalId);
  });
}
